import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

export interface IPostResponse {
  post: IPost;
}

interface IBody {
    visibleToBrand: string;
}

export function useChangePostVisibilityAdminHttp() {
  return usePutHttp<IBody, IPostResponse>({
    path: "/admin/posts/:id/change-visibility",
  });
}
